export function formatEventDateRange(startsAt, endsAt) {
  if (!startsAt) return ''

  const start = new Date(startsAt)
  const end = endsAt ? new Date(endsAt) : null
  const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
  const timeFormatter = new Intl.DateTimeFormat('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  })

  const startDate = dateFormatter.format(start)
  const startTime = timeFormatter.format(start)

  if (!end) {
    return `${startDate}, ${startTime}`
  }

  const endDate = dateFormatter.format(end)
  const endTime = timeFormatter.format(end)

  if (startDate === endDate) {
    return `${startDate}, ${startTime} — ${endTime}`
  }

  return `${startDate}, ${startTime} — ${endDate}, ${endTime}`
}

export function formatEventDateShort(value) {
  if (!value) return ''

  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

export { visibilityLabel } from './tripFormat'

export function toDatetimeLocalValue(value) {
  if (!value) return ''

  const date = new Date(value)
  const pad = (num) => String(num).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export function monthRange(date) {
  const start = new Date(date.getFullYear(), date.getMonth(), 1)
  const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
  return { from: start.toISOString(), to: end.toISOString() }
}

export function monthLabel(date) {
  return new Intl.DateTimeFormat('ru-RU', { month: 'long', year: 'numeric' }).format(date)
}
